import React, { Component } from 'react';
import _ from 'lodash';
import { Field } from 'redux-form';
import { SkyLightStateless } from 'react-skylight';
import { InputField } from '../Common/inputField';
import { Breadcrumb, Grid, Row, Col, Panel, Tabs, Tab, ButtonToolbar, Button, Form, DropdownButton, MenuItem, InputGroup, Input } from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { Selection, MultiSelection, DisabledSelection} from '../Common/selection'
import { Translate, Localize } from 'react-redux-i18n';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import RowRenderer from '../Common/rowRenderer';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { DateFormatter, formatDate } from '../Common/dateFormat';
import ConfirmActionModal from '../Common/confirmActionModal';

const getBsStyle = (input, value)=>{
  return input == value ? "success":"primary"
}

let renderRadio = props => {
  return (
    <div className="form-group">
      <div className="col-xs-6">
        <label>
          <input
            {...props.input}
            type="radio"
            value="waive"
            checked={props.input.value === "waive"}
          />
          <Translate value="waive" />
        </label>
      </div>
      <div className="col-xs-6">
        <label>
          <input
            {...props.input}
            type="radio"
            value="noWaive"
            checked={props.input.value === "noWaive"}
          />
          <Translate value="no_waive" />
        </label>
      </div>
    </div>
  )
}

const renderDatePicker = (fieldName, placeholder) => {
  return (
    <Button bsStyle="primary">
      <Field name={fieldName} placeholder={placeholder} component={ DatePicker }/>
    </Button>
  )
}

let renderInvoiceDateRadio = props => {
  let FromDate = "FromDate";
  let ToDate = "ToDate";
  if(props.input.name == "InvoiceDateBySequence") {
    FromDate = FromDate + "BySequence";
    ToDate = ToDate + "BySequence";
  }
  return (
    <ButtonToolbar className="mb-md radio-filter-buttons">
      <Button bsStyle={getBsStyle(props.input.value, "all")}>
        <div className="radio">
          <label for="all-radio-filter">
            <input
              {...props.input}
              type="radio"
              id="all-radio-filter"
              className="statusFilterRadios"
              value="all"
              checked={props.input.value === "all"}
            />
            <Translate value="all" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, "range")}>
        <div className="radio">
          <label for="range-radio-filter">
            <input
              {...props.input}
              type="radio"
              id="range-radio-filter"
              className="statusFilterRadios"
              value="range"
              checked={props.input.value === "range"}
            />
            <Translate value="range" />
          </label>
        </div>
      </Button>
      {props.input.value === "range" && renderDatePicker(FromDate, "Start")}
      {props.input.value === "range" && renderDatePicker(ToDate, "End")}
    </ButtonToolbar>
  )
}


class APDetail extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
      super();
      this.state = {
          dirty: false,

          invoices: {
            rows: [],
            sortColumn: null,
            sortDirection: null
          },
          selectedInvoices: {
            rows: [],
            sortColumn: null,
            sortDirection: null
          },
          invoicesBySequence: {
            rows: [],
            sortColumn: null,
            sortDirection: null
          },
          unpaidAmount: 0,
          totalAmount: 0,
          checkAuthorizeOpen: false,
          invoicesKey: 1,
          action: null,
      };
      this.moveInvoices = this.moveInvoices.bind(this);
      this.checkAuthorize = this.checkAuthorize.bind(this);
      this.openCheckAuthorize = this.openCheckAuthorize.bind(this);
      this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
      this.handleSelect = this.handleSelect.bind(this);
      this.clearTable = this.clearTable.bind(this);
    }

    componentWillMount() {
        if(this.context.router.routes[1].path == "AP/new") {
          this.props.clearAPDetail();
          this.props.setDefaultOfForm('Waive', 'noWaive', 'apDetail');
        }
        else if(this.props.apDetail) {
          let rows = [...this.props.apDetail.Invoices];
          let invoicesBySequence = {...this.state.invoicesBySequence, rows};
          let unpaidAmount = this.state.unpaidAmount;
          this.props.apDetail.Invoices.map(r => {
              unpaidAmount += r.UnpaidAmount;
          })
          let totalAmount = parseFloat(unpaidAmount) || 0;
          this.setState(...this.state, {invoicesBySequence, unpaidAmount, totalAmount});
          if(this.props.apDetail.Waive > 0) {
            this.props.setDefaultOfForm('Waive', 'waive', 'apDetail')
          }
          else {
            this.props.setDefaultOfForm('Waive', 'noWaive', 'apDetail');
          }
        }
        this.props.clearCredits();
        this.props.fetchVendors();
        this.props.setDefaultOfForm('InvoiceDate', 'all', 'apDetail');
        this.props.setDefaultOfForm('InvoiceDateBySequence', 'all', 'apDetail');
    }

    componentWillReceiveProps(nextProps) {
      if(nextProps.vendor_id && nextProps.vendor_id != this.props.vendor_id) {
        let fromDate;
        let toDate;
        let invoiceDate;
        if(this.state.invoicesKey == 1) {
          fromDate = formatDate(this.props.fromDate);
          toDate = formatDate(this.props.toDate);
          invoiceDate = this.props.invoiceDate;
        }
        else if(this.state.invoicesKey == 2) {
          fromDate = formatDate(this.props.fromDateBySequence);
          toDate = formatDate(this.props.toDateBySequence);
          invoiceDate = this.props.invoiceDateBySequence;
        }
        this.props.fetchVendorDetail(nextProps.vendor_id.value || nextProps.vendor_id);
        this.props.fetchAPCredits(nextProps.vendor_id.value || nextProps.vendor_id);
        if(!this.props.apDetail) {
          this.props.fetchAPInvoices(
            nextProps.vendor_id.value || nextProps.vendor_id,
            invoiceDate,
            fromDate,
            toDate
          );
        }
      }
      if(nextProps.invoices && nextProps.invoices != this.props.invoices) {
        if(this.state.invoicesKey == 1) {
          const invoicesBySequence = {...this.state.invoicesBySequence, rows: nextProps.invoices};
          let totalAmount = 0;
          nextProps.invoices.map(invoice => {
            totalAmount += parseFloat(invoice.UnpaidAmount) || 0;
          })
          totalAmount = totalAmount.toFixed(2);
          this.setState({invoicesBySequence, totalAmount});
        }
        else if(this.state.invoicesKey == 2) {
          const invoices = {...this.state.invoices, rows: nextProps.invoices};
          const selectedInvoices = {...this.state.selectedInvoices, rows: []};
          this.setState({invoices, selectedInvoices});
        }
      }
      if(nextProps.invoiceDate && nextProps.invoiceDate != this.props.invoiceDate) {
        let fromDate = formatDate(this.props.fromDate)
        let toDate = formatDate(this.props.toDate)
        if(this.props.vendor_id && !this.props.apDetail) {
          this.props.fetchAPInvoices(
            this.props.vendor_id.value || this.props.vendor_id,
            nextProps.invoiceDate,
            fromDate,
            toDate
          );
        }
      }
      if(nextProps.fromDate && nextProps.fromDate != this.props.fromDate) {
        let fromDate = formatDate(nextProps.fromDate)
        let toDate = formatDate(this.props.toDate)
        if(this.props.vendor_id && !this.props.apDetail) {
          this.props.fetchAPInvoices(
            this.props.vendor_id.value || this.props.vendor_id,
            this.props.invoiceDate,
            fromDate,
            toDate
          );
        }
      }
      if(nextProps.toDate && nextProps.toDate != this.props.toDate) {
        let fromDate = formatDate(this.props.fromDate)
        let toDate = formatDate(nextProps.toDate)
        if(this.props.vendor_id && !this.props.apDetail) {
          this.props.fetchAPInvoices(
            this.props.vendor_id.value || this.props.vendor_id,
            this.props.invoiceDate,
            fromDate,
            toDate
          );
        }
      }
      if(nextProps.invoiceDateBySequence && nextProps.invoiceDateBySequence != this.props.invoiceDateBySequence) {
        let fromDateBySequence = formatDate(this.props.fromDateBySequence)
        let toDateBySequence = formatDate(this.props.toDateBySequence)
        if(this.props.vendor_id && !this.props.apDetail) {
          this.props.fetchAPInvoices(
            this.props.vendor_id.value || this.props.vendor_id,
            nextProps.invoiceDateBySequence,
            fromDateBySequence,
            toDateBySequence
          );
        }
      }
      if(nextProps.fromDateBySequence && nextProps.fromDateBySequence != this.props.fromDateBySequence) {
        let fromDateBySequence = formatDate(nextProps.fromDateBySequence)
        let toDateBySequence = formatDate(this.props.toDateBySequence)
        if(this.props.vendor_id && !this.props.apDetail) {
          this.props.fetchAPInvoices(
            this.props.vendor_id.value || this.props.vendor_id,
            this.props.invoiceDateBySequence,
            fromDateBySequence,
            toDateBySequence
          );
        }
      }
      if(nextProps.toDateBySequence && nextProps.toDateBySequence != this.props.toDateBySequence) {
        let fromDateBySequence = formatDate(this.props.fromDateBySequence)
        let toDateBySequence = formatDate(nextProps.toDateBySequence)
        if(this.props.vendor_id && !this.props.apDetail) {
          this.props.fetchAPInvoices(
            this.props.vendor_id.value || this.props.vendor_id,
            this.props.invoiceDateBySequence,
            fromDateBySequence,
            toDateBySequence
          );
        }
      }
      if(nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess != this.props.checkPasswordSuccess) {
        this.closeCheckAuthorize();
        let formProps = {
          Vendor: this.props.vendor_id,
          TotalPayment: this.props.totalPayment,
          Method: this.props.method,
          CheckNum: this.props.checkNum,
          Account: this.props.account,
          Discount: this.props.discount,
          Waive: this.props.waive,
          Note: this.props.note,
        }
        if(this.state.action == "apply") {
          this.handleFormSubmit(formProps);
        }
        else if(this.state.action == "remove") {
          this.props.deleteAP(this.props.apDetail.Payment_id);
        }
      }
    }

    calculateWaiveAmount() {
      let discount = parseFloat(this.props.discount) || 0;
      let totalAmount = parseFloat(this.state.totalAmount) || 0;
      let finalAmount = (100-discount)/100*totalAmount;
      finalAmount = finalAmount.toFixed(2) || 0;
      let totalPayment = parseFloat(this.props.totalPayment) || 0;
      let waiveAmount = finalAmount-totalPayment;
      waiveAmount = waiveAmount.toFixed(2);
      return waiveAmount;
    }

    handleFormSubmit(formProps) {
        let waiveAmount = this.calculateWaiveAmount();
        let rows;
        if(this.state.invoicesKey == 1) {
          rows = Data.Selectors.getRows(this.state.invoicesBySequence)
        }
        else if(this.state.invoicesKey == 2) {
          rows = Data.Selectors.getRows(this.state.selectedInvoices)
        }
        if(this.props.apDetail) {
          if(!this.checkPermission("change_account_receivable")){
            this.props.editAP(formProps, waiveAmount, rows);
          }
          else{
            alert("You have no permission!");
          }
        }
        else{
          this.props.createAP(formProps, waiveAmount, rows);
        }
    }

    handleSelect(invoicesKey) {
      if(invoicesKey == 1 && this.state.selectedInvoices.rows.length == 0) {
        let fromDateBySequence = formatDate(this.props.fromDateBySequence)
        let toDateBySequence = formatDate(this.props.toDateBySequence)
        if(this.props.vendor_id && !this.props.apDetail) {
          this.props.fetchAPInvoices(
            this.props.vendor_id.value || this.props.vendor_id,
            this.props.invoiceDateBySequence,
            fromDateBySequence,
            toDateBySequence
          );
        }
        this.setState({invoicesKey})
      }
      else if(invoicesKey == 2 && this.state.invoicesBySequence.rows.length == 0) {
        let fromDate = formatDate(this.props.fromDate)
        let toDate = formatDate(this.props.toDate)
        if(this.props.vendor_id && !this.props.apDetail) {
          this.props.fetchAPInvoices(
            this.props.vendor_id.value || this.props.vendor_id,
            this.props.invoiceDate,
            fromDate,
            toDate
          );
        }
        this.setState({invoicesKey})
      }
      else {
        alert("clear current table first!")
      }
    }

    clearTable(table) {
      if(table == "invoicesBySequence") {
        let invoicesBySequence = {...this.state.invoicesBySequence, rows: []}
        this.setState({invoicesBySequence, totalAmount: 0})
      }
      else if(table == "selectedInvoices") {
        let invoicesRows = [...this.state.invoices.rows, ...this.state.selectedInvoices.rows]
        let invoices = {...this.state.invoices, rows: invoicesRows}
        let selectedInvoices = {...this.state.selectedInvoices, rows: []}
        this.setState({invoices, selectedInvoices, totalAmount: 0})
      }
    }

    checkAuthorize(password) {
      this.props.checkPassword(password);
    }

    openCheckAuthorize(action) {
      this.props.clearCheckPassword();
      this.setState({checkAuthorizeOpen: true, action})
    }

    closeCheckAuthorize() {
      this.setState({checkAuthorizeOpen: false})
    }

    getVendorOptions(field) {
        var vendorOptions = [];
        this.props.vendors.map(vendor => {
            vendorOptions.push({ value: vendor.Vendor_id, label: vendor[field] })
        });
        return vendorOptions;
    }

    getCreditOptions() {
        let creditOptions = [];
        if(this.props.credits) {
          this.props.credits.map(credit => { //check the field name of credits when backend finish the API
            creditOptions.push({value: credit.SalesReturn_id, label: credit.SRNum + ' | ' + credit.FinalPrice})
          });
        }
        return creditOptions;
    }

    getBillingAddress() {
      const { currentVendorDetail } = this.props;
      let Address1 = "";
      let Address2 = "";
      if(currentVendorDetail && currentVendorDetail.Billing) {
          Address1 = currentVendorDetail.Billing.Street;
          Address2 = currentVendorDetail.Billing.City + " " + currentVendorDetail.Billing.State + currentVendorDetail.Billing.Zip;
      }
      return [Address1, Address2];
    }

    moveInvoices(invoice, from, to) {
      let invoices = {...this.state.invoices};
      let selectedInvoices = {...this.state.selectedInvoices};
      let index;
      if(from == "invoices") {
        index = _.findIndex(invoices.rows, {WarehouseReceive_id: invoice.WarehouseReceive_id});
        if(index > -1)
          invoices.rows.splice(index, 1);
        index = _.findIndex(selectedInvoices.rows, {WarehouseReceive_id: invoice.WarehouseReceive_id});
        if(index == -1)
          selectedInvoices.rows.push(invoice);
      }
      else if(from == "selectedInvoices") {
        index = _.findIndex(selectedInvoices.rows, {WarehouseReceive_id: invoice.WarehouseReceive_id});
        if(index > -1)
          selectedInvoices.rows.splice(index, 1);
        index = _.findIndex(invoices.rows, {WarehouseReceive_id: invoice.WarehouseReceive_id});
        if(index == -1)
          invoices.rows.push(invoice);
      }
      let totalAmount = 0;
      selectedInvoices.rows.map(r => {
        totalAmount += parseFloat(r.UnpaidAmount) || 0;
      })
      this.setState({invoices, selectedInvoices, totalAmount})
    }

    renderVendors() {
        if (this.props.vendorsIsLoading && !this.props.vendorsError) return <Spinner/>
        else if (this.props.vendorsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.vendorsError)}</div></ContentWrapper>
        else {
            let vendorNameOptions = this.getVendorOptions("Name"); // Return a JSON in the format of React-Select's options
            let vendorNumOptions = this.getVendorOptions("VendorNum");
            let vendorPhoneOptions = this.getVendorOptions("Telephone"); // Return a JSON in the format of React-Select's options
            let vendorDescOptions = this.getVendorOptions("Description");
            let billingAddress = ["", ""];
            const { vendor_id, currentVendorDetail } = this.props;
            let contact = null;
            let phone = null;
            if(vendor_id && currentVendorDetail && currentVendorDetail.Billing) {
              contact = currentVendorDetail.Billing.FirstName + " " + currentVendorDetail.Billing.LastName
              phone = currentVendorDetail.Billing.Telephone
              billingAddress = this.getBillingAddress();
            }
            let SelectionForVendor = (this.props.apDetail) ? DisabledSelection : Selection;
            return (
                <div>
                  <Row className="mb0">
                    <Col sm={ 4 }>
                        <label className="col-sm-4 inlineLabel" >
                          <Translate value="vendor_no" />
                          <span style={{color: 'red'}} >*</span>
                        </label>
                        <Col sm={ 8 } className="mb-md">
                          <Field name="Vendor" component={SelectionForVendor} matchPos='any' options={vendorNumOptions}/>
                        </Col>
                        <label className="col-sm-4 inlineLabel" >
                          <Translate value="vendor_name" />
                        </label>
                        <Col sm={ 8 } className="mb-md">
                          <Field name="Vendor" component={SelectionForVendor} matchPos='any' options={vendorNameOptions}/>
                        </Col>
                    </Col>
                    <Col sm={ 4 }>
                        <label className="col-sm-4 inlineLabel" >
                          <Translate value="phone" />
                        </label>
                        <Col sm={ 8 } className="mb-md">
                          <Field name="Vendor" component={SelectionForVendor} matchPos='any' options={vendorPhoneOptions}/>
                        </Col>
                        <label className="col-sm-4 inlineLabel" >
                          <Translate value="description" />
                        </label>
                        <Col sm={ 8 } className="mb-md">
                          <Field name="Vendor" component={SelectionForVendor} matchPos='any' options={vendorDescOptions}/>
                        </Col>
                    </Col>
                    <Col sm={ 4 }>
                        <label className="col-sm-3">
                          <Translate value="contact" />:
                        </label>
                        <Col sm={ 9 }>
                            {contact}
                        </Col>
                        <label className="col-sm-3">
                          <Translate value="phone" />:
                        </label>
                        <Col sm={ 9 }>
                            {phone}
                        </Col>
                        <label className="col-sm-3">
                          <Translate value="address" />:
                        </label>
                        {<Col sm={ 9 }>
                          {billingAddress[0]}
                          <br/>
                          {billingAddress[1]}
                        </Col>}
                      </Col>
                    </Row>
                </div>
            )
        }
    }

    renderInvoices() {
        if (this.props.invoicesIsLoading && !this.props.invoicesError) return <Spinner/>
        else if (this.props.invoicesError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.invoicesError)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.invoices);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var invoices = Object.assign({}, this.state.invoices, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({invoices});
            }

            // Column difinition

            const columns = [
              {
                  key: 'WarehouseReceiveNum',
                  name: <Translate value="receive_num" />,
                  width: 110,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'PostingDate',
                  name: <Translate value="date" />,
                  width: 90,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  formatter: DateFormatter
              },
              {
                  key: 'Amount',
                  name: <Translate value="amount" />,
                  width: 80,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'UnpaidAmount',
                  name: <Translate value="balance" />,
                  width: 80,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
            ]

            return (
                <div style={{ maxWidth: '100%' }} id="APDetail-dataGrid1">
                    <ReactDataGrid
                        rowRenderer={
                          <RowRenderer
                            onDoubleClick={this.moveInvoices}
                            from="invoices"
                            to="selectedInvoices"
                          />
                        }
                        onGridSort={handleGridSort}
                        columns={columns}
                        rowHeight={25}
                        minHeight={390}
                        rowGetter={rowGetter}
                        rowsCount={getSize()}
                    />
                </div>
            )
        }
    }

    renderSelectedInvoices() {
        // if (this.props.vendorsIsLoading && !this.props.vendorsError) return <Spinner/>
        // else if (this.props.vendorsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.vendorsError)}</div></ContentWrapper>
        // else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.selectedInvoices);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var selectedInvoices = Object.assign({}, this.state.selectedInvoices, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({selectedInvoices});
            }

            // Column difinition

            const columns = [
              {
                  key: 'WarehouseReceiveNum',
                  name: <Translate value="receive_num" />,
                  width: 110,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'PostingDate',
                  name: <Translate value="date" />,
                  width: 90,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  formatter: DateFormatter
              },
              {
                  key: 'Amount',
                  name: <Translate value="amount" />,
                  width: 80,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'UnpaidAmount',
                  name: <Translate value="balance" />,
                  width: 80,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
            ]

            return (
                <div style={{ maxWidth: '100%' }} id="APDetail-dataGrid2">
                    <ReactDataGrid
                        rowRenderer={
                          <RowRenderer
                            onDoubleClick={this.moveInvoices}
                            from="selectedInvoices"
                            to="invoices"
                          />
                        }
                        onGridSort={handleGridSort}
                        columns={columns}
                        rowHeight={25}
                        minHeight={390}
                        rowGetter={rowGetter}
                        rowsCount={getSize()}
                    />
                </div>
            )
        // }
    }

    renderInvoicesBySequence() {
      const getRows = () => {
          return Data.Selectors.getRows(this.state.invoicesBySequence);
      }

      const getSize = () => {
          return getRows().length;
      }

      const rowGetter = rowIdx => {
          var rows = getRows();
          return rows[rowIdx];
      }

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
          var invoicesBySequence = Object.assign({}, this.state.invoicesBySequence, { sortColumn: sortColumn, sortDirection: sortDirection });
          this.setState({invoicesBySequence});
      }

      // Column difinition

      const columns = [
        {
            key: 'WarehouseReceiveNum',
            name: <Translate value="receive_num" />,
            width: 110,
            resizable: true,
            sortable: true,
            filterable: true
        },
        {
            key: 'PostingDate',
            name: <Translate value="date" />,
            width: 90,
            resizable: true,
            sortable: true,
            filterable: true,
            formatter: DateFormatter
        },
        {
            key: 'Amount',
            name: <Translate value="amount" />,
            width: 80,
            resizable: true,
            sortable: true,
            filterable: true
        },
        {
            key: 'UnpaidAmount',
            name: <Translate value="balance" />,
            width: 80,
            resizable: true,
            sortable: true,
            filterable: true
        },
      ]

      return (
          <div style={{ maxWidth: '100%' }} id="APDetail-dataGrid3">
              <ReactDataGrid
                  onGridSort={handleGridSort}
                  columns={columns}
                  rowHeight={25}
                  minHeight={390}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
              />
          </div>
      )
    }

    renderCheckNum() {
      return (
        <Field name="CheckNum" component={InputField} />
      )
    }

    renderCredits() {
        if (this.props.creditsIsLoading && !this.props.creditsError) return <Spinner/>
        else if (this.props.creditsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.creditsError)}</div></ContentWrapper>
        else {
            let creditOptions = this.getCreditOptions(); // Return a JSON in the format of React-Select's options
            return (
                <Field name="Credits" component={MultiSelection} options={creditOptions}/>
            )
        }
    }

    renderResponse() {
      const { apCreated, apEdited, apCreateError, apEditError, apIsCreating, apIsEditing } = this.props;
      if (apCreated || apEdited) return <ContentWrapper><div className="alert alert-success">Success!</div></ContentWrapper>
      else if ((apIsCreating && !apCreateError)||(apIsEditing && !apEditError)) return <ContentWrapper><div className="alert alert-info">...<Translate value="reading_data" /></div></ContentWrapper>
      else if (apCreateError || apEditError) return <ContentWrapper><div className="alert alert-danger">{apCreateError}</div></ContentWrapper>
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        const { handleSubmit, apCreated, apEdited, apCreateError, apEditError, apIsCreating, apIsEditing } = this.props;
        const PaymentMethodOptions = [
          {value: "Check", label: "Check"},
          {value: "MoneyOrder", label: "Money Order"},
          {value: "CompanyCheck", label: "Company Chk"},
          {value: "CashCheck", label: "Cash Chk"},
          {value: "PersonalCheck", label: "Personal Chk"},
          {value: "WireTransfer", label: "Wire Transfer"},
          {value: "CreditCard", label: "Credit Card"},
          {value: "BadDebt", label: "Bad Debt"},
          {value: "Credit", label: "Credit"},
        ];
        const accountOptions = [
          {value: "Checking/Saving:1140-EAST WEST BANK #5883", label: "Checking/Saving:1140-EAST WEST BANK #5883"},
          {value: "Checking/Saving:1130-China Trust Bank(USA)#3668", label: "Checking/Saving:1130-China Trust Bank(USA)#3668"}
        ]
        let paymentMethodIsCredit = this.props.method == "Credit" || (this.props.method && this.props.method.value == "Credit");
        const bySequenceTitle = (<Translate value="by_sequence" />);
        const byInvoicesTitle = (<Translate value="by_invoices" />);
        let discount = parseFloat(this.props.discount) || 0;
        let totalAmount = parseFloat(this.state.totalAmount) || 0;
        let finalAmount = (100-discount)/100*totalAmount;
        finalAmount = finalAmount.toFixed(2) || 0;
        let waiveAmount;
        if(this.props.apDetail) {
          waiveAmount = this.props.apDetail.Waive;
        }
        else {
          waiveAmount = this.calculateWaiveAmount();
        }

        let createDialogStyle = {
            width: '550px',
            height: '300px',
            marginLeft: '-15%',
        };

        return (
          <ContentWrapper>
            <form method="get" action="#">
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="ar_slashsign_ap" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active="true">
                  <Translate value="ap_vendor_payment" />
                </Breadcrumb.Item>
              </Breadcrumb> {/* End Navigation Trail */}
              <Grid id="AP-detail">
                <ButtonToolbar>
                  <Button
                    bsStyle="danger"
                    type="button"
                    onClick={() => { this.context.router.push('/AP')}}
                  >
                    <em className="fa fa-close"/>
                  </Button>
                </ButtonToolbar>
                <Panel id="vendors">
                  { this.renderVendors() }
                </Panel>
                <Tabs activeKey={ this.state.invoicesKey } justified onSelect={this.handleSelect}>
                  <Tab eventKey={ 1 } title={bySequenceTitle}>
                    <Row id="date-range-picker" className="form-horizontal">
                      <div className="col-sm-7">
                        <label className="floatLeft">
                          <Translate value="invoice_date" />
                        </label>
                        <Field name="InvoiceDateBySequence" component={ renderInvoiceDateRadio } />
                      </div>
                      <div className="col-sm-offset-3 col-sm-2">
                        <label className="mr-lg">
                          <Translate value="total_balance" /> :
                          {this.state.totalAmount}
                        </label>
                        <Button
                          bsStyle="danger"
                          className="floatRight"
                          onClick={()=>{this.clearTable("invoicesBySequence")}}
                        >
                          <Translate value="clear" />
                        </Button>
                      </div>
                    </Row>
                    <Row>
                      <Col sm = { 12 }>
                        { this.renderInvoicesBySequence() }
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey={ 2 } title={byInvoicesTitle}>
                    <Row id="date-range-picker" className="form-horizontal">
                      <div className="col-sm-7">
                        <label className="floatLeft">
                          <Translate value="invoice_date" />
                        </label>
                        <Field name="InvoiceDate" component={ renderInvoiceDateRadio } />
                      </div>
                      <div className="col-sm-offset-3 col-sm-2">
                        <Button
                          bsStyle="danger"
                          className="floatRight"
                          onClick={()=>{this.clearTable("selectedInvoices")}}
                        >
                          <Translate value="clear" />
                        </Button>
                      </div>
                    </Row>
                    <Row>
                      <Col sm = { 6 }>
                        { this.renderInvoices() }
                      </Col>
                      <Col sm = { 6 }>
                        { this.renderSelectedInvoices() }
                      </Col>
                    </Row>
                  </Tab>
                </Tabs>
                <Panel id="check-out-information">
                  <Row>
                    <label className="col-sm-1 text-nowrap inlineLabel" >
                      <Translate value="payment_method" />
                      <span className="asteriksReq">*</span>
                    </label>
                    <Col sm={ 2 }>
                      <Field name="Method" className="select-menu-drop-up" component={Selection} matchPos='any' options={PaymentMethodOptions}/>
                    </Col>
                    <label className="col-sm-1 inlineLabel" >
                      <Translate value="check_number" />
                    </label>
                    <Col sm={ 2 }>
                      { paymentMethodIsCredit && this.renderCredits() }
                      { !paymentMethodIsCredit && this.renderCheckNum() }
                    </Col>
                    <label className="col-sm-1 inlineLabel" >
                      <Translate value="discount" />
                    </label>
                    <Col sm={ 1 }>
                      <Field name="Discount" component={InputField}/>
                    </Col>
                    <Col sm={ 2 }>
                      <Field name="Waive" component={ renderRadio } />
                    </Col>
                    <label className="col-sm-1">
                      <Translate value="waive_amount" /> :
                    </label>
                    <label className="col-sm-1">
                      {waiveAmount}
                    </label>
                  </Row>
                  <Row>
                    <label className="col-sm-1 inlineLabel" >
                      <Translate value="account" />
                      <span style={{color: 'red'}} >*</span>
                    </label>
                    <Col sm={ 2 }>
                      <Field name="Account" component={InputField} />
                    </Col>
                    <label className="col-sm-1 text-nowrap inlineLabel" >
                      <Translate value="pay_amount" />
                      <span className="asteriksReq">*</span>
                    </label>
                    <Col sm={ 1 }>
                      <Field name="TotalPayment" component={InputField}/>
                    </Col>
                    <label className="col-sm-offset-5 col-sm-1">
                      <Translate value="final_dollarsign" /> :
                    </label>
                    <label className="col-sm-1">
                      {finalAmount}
                    </label>
                  </Row>
                  <Row id="hint">
                    <label className="col-sm-1 inlineLabel" >
                      <Translate value="hint" />
                    </label>
                    <Col sm={ 5 }>
                      <Field name="Note" component={InputField} />
                    </Col>
                  </Row>
                  <ButtonToolbar id="apply-and-remove-buttons">
                    <Button
                      bsStyle="primary"
                      type="button"
                      onClick={handleSubmit( ()=>{this.openCheckAuthorize("apply")} )}
                      disabled={this.props.apDetail}
                      >
                      <Translate value="apply" />
                    </Button>
                    <Button
                      bsStyle="danger"
                      type="button"
                      onClick={()=>{this.openCheckAuthorize("remove")}}
                      disabled={!this.props.apDetail}
                      >
                      <Translate value="remove" />
                    </Button>
                  </ButtonToolbar>
                </Panel>
                <Row>
                  {this.renderResponse()}
                </Row>
              </Grid>
            </form>
            <SkyLightStateless
              dialogStyles={createDialogStyle}
              isVisible={this.state.checkAuthorizeOpen}
              onCloseClicked={this.closeCheckAuthorize}
            >
              <ConfirmActionModal
                case="confirmPassword"
                closeC={this.checkAuthorize}
                checkPasswordFailure={this.props.checkPasswordFailure}
              />
            </SkyLightStateless>
          </ContentWrapper>
        )
    }
}

export default APDetail



// WEBPACK FOOTER //
// ./master/jsx/components/AP/APDetail.jsx